import type { FarmUserPermissions } from "@/constants/permissions"
import type { Reducer } from "@reduxjs/toolkit"

import * as AppStorage from "@/base/async-storage"
import {
  acceptTermsOfServiceAsync,
  loadActiveUserAsync,
} from "@/base/farmhq-api"
import { loadActiveFarmAsync } from "@/base/load-app"

import { createAction, createSlice, isRejected } from "@reduxjs/toolkit"

import type { RootState } from "./root.reducer"

import type {
  MissingPermissions,
  PermissionDeniedBase,
  RequestBlockedInDemo,
} from "@/base/check-permissions"
import { denyPermission } from "./actions"

interface PermissionsState {
  farmUserPermissions?: FarmUserPermissions
  isAdmin?: boolean
  isAdminModeEnabled?: boolean
  permissionDenied?: MissingPermissions | RequestBlockedInDemo
  termsOfServiceAccepted?: boolean
}

const initialState: PermissionsState = {}

export const clearPermissionDenied = createAction("CLEAR PERMISSION DENIED")

const slice = createSlice({
  extraReducers: (builder) =>
    builder
      .addCase(
        AppStorage.readLocalStorageAsync.fulfilled,
        (state, { payload }) => {
          state.isAdminModeEnabled = payload.isAdminModeEnabled
        },
      )
      .addCase(loadActiveUserAsync.fulfilled, (state, { payload }) => {
        state.termsOfServiceAccepted =
          payload.userData.termsOfServiceAccepted === true

        if (payload.userData.isAdmin === true) {
          state.isAdmin = true
        } else {
          state.isAdmin = false
          state.isAdminModeEnabled = undefined
        }
      })
      .addCase(loadActiveFarmAsync.fulfilled, (state, { payload }) => {
        state.farmUserPermissions = payload.userPermissions ?? undefined
      })
      .addCase(denyPermission, (state, { payload }) => {
        if (payload.code === "REQUEST_BLOCKED_IN_DEMO") {
          state.permissionDenied = payload
        } else {
          state.permissionDenied = payload
        }
      })
      .addCase(clearPermissionDenied, (state) => {
        state.permissionDenied = undefined
      })
      .addCase(AppStorage.setAdminMode.pending, (state, { meta }) => {
        if (state.isAdmin === true) {
          state.isAdminModeEnabled = meta.arg
        }
      })
      .addCase(acceptTermsOfServiceAsync.fulfilled, (state) => {
        state.termsOfServiceAccepted = true
      })
      .addMatcher(isRejected, (state, action) => {
        if (
          action.meta.rejectedWithValue &&
          typeof action.payload === "object"
        ) {
          const value = action.payload as PermissionDeniedBase | null
          if (value) {
            if (
              value.code === "REQUEST_BLOCKED_IN_DEMO" ||
              value.code === "MISSING_PERMISSIONS"
            ) {
              state.permissionDenied = value as
                | MissingPermissions
                | RequestBlockedInDemo
            }
          }
        }
      }),
  initialState,
  name: "permissions",
  reducers: {},
})

const userPermissions: Reducer<PermissionsState> = slice.reducer
export default userPermissions

export function getFarmUserPermissionsFromState(
  state: RootState,
): FarmUserPermissions | undefined {
  return state.userPermissions.farmUserPermissions
}
// export function getUserHasPermission(
//   state: RootState,
//   permissionName: FarmUserPermissionName,
// ) {
//   return getFarmUserPermissionsFromState(state)?.[permissionName] === true
// }

// export function getUserHasAllPermissions(
//   state: RootState,
//   toCheck:
//     | FarmUserPermissionName
//     | FarmUserPermissionName[]
//     | null
//     | undefined,
// ) {
//   let required: FarmUserPermissionName[] = []
//   if (typeof toCheck === "string") {
//     required = [toCheck]
//   } else if (Array.isArray(toCheck)) {
//     required = toCheck
//   }
//   if (required.length === 0) {
//     //  User has all permissions
//     return true
//   }

//   const provided = getFarmUserPermissionsFromState(state)

//   return required.every((key) => {
//     if (provided) {
//       return provided[key]
//     }
//     return false
//   })
// }
// export function useUserHasPermissions(
//   ...permissionNames: FarmUserPermissionName[]
// ) {
//   return useSelector((state: RootState) => {
//     const provided = getFarmUserPermissionsFromState(state)
//     return permissionNames.every((key) => {
//       if (provided) {
//         return provided[key]
//       }
//       return false
//     })
//   })
// }
